import { gql } from '@apollo/client';

import { BREAKDOWN_FIELDS } from 'gql/breakdownFragment';

export const FETCH_RIDE_BY_ID = gql`
	query rideSearchWithFilters($rideId: ID!) {
		getRideById(rideId: $rideId) {
			id
			tripNumber
			status
			departure
			lineCode
			stations {
				id
				code
				name
				timezone
				departure
				arrival
				isOperational
				city {
					name
					id
				}
			}
			workAssignmentSequences {
				isMultiRide
				isEditable
				sequenceGroupId
				rideId
				crewMember {
					id
					fullName
				}
				breakdown {
					...BreakdownFields
				}

				fromStation {
					id
					name
				}
				toStation {
					id
					name
				}
				fromTimestamp
				toTimestamp
				activityType
				status
				workAssignments {
					crewMember {
						id
						fullName
					}
					status
					version
					id
					fromStation {
						id
						name
					}
					toStation {
						id
						name
					}
				}
				run {
					name
					id
				}
				job {
					id
					code
					runId
				}
				extraActivities {
					fromTimestamp
					toTimestamp
					id
					version
					status
					fromStation {
						id
						code
					}
					toStation {
						id
						code
					}
					activityType
				}
				breakdown {
					...BreakdownFields
				}
			}
			vehicleAssignments {
				mobilityPartnerName
				plateNumber
				busNumber
				vehicleType
				fromStationId
				toStationId
			}
			activityTypeConfigs {
				activityType
				limit
			}
			runs {
				id
				name
				description
				effectiveDate
				expireDate
				concessionOwners {
					id
					name
				}
				runCity {
					id
					name
					timezone
				}
			}
			jobs {
				id
				code
				runId
				distanceKm
				durationSeconds
			}
		}
	}
	${BREAKDOWN_FIELDS}
`;
